export default __webpack_public_path__ + "static/media/IMG_0259 copie.9979d23a.jpg";